/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from 'react';
import Help from "@carbon/icons-react/lib/help/20";
import { AppMsg } from '../utils';

//Function for Main Navigation(Header) About Button
export function help(tririgaContextUrl) {
    
    return({
    label:AppMsg.getMessage(AppMsg.APP_HELP),
    btnContent: <Help fill="white" description="Icon" className="about-icon"/>,
    element:'button',
    onClick:() => {_helpBtnClicked(tririgaContextUrl)},
    })
}

//Function when about button is clicked
function _helpBtnClicked(tririgaContextUrl){
    let path = `${tririgaContextUrl}/html/en/default/common/helpHeader.jsp?key=Portal-Help`;
    window.open(path,"help_window","width=790,height=570"); 
}